import {getSiteUrl} from "@/helpers/functions";

export interface BreadcrumbItem {
    name: string;
    url?: string;
}

export interface SeoSchemaBreadcrumbProps {
    items: BreadcrumbItem[];
}

const toAbsoluteUrl = (siteUrl: string, url: string): string => {
    if (/^https?:\/\//i.test(url)) return url;
    const path = url.startsWith("/") ? url : `/${url}`;
    return `${siteUrl}${path}`;
};

export function SeoSchemaBreadcrumb({items}: SeoSchemaBreadcrumbProps) {
    if (!items.length) return null;

    const siteUrl = getSiteUrl();
    const schema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": items.map((item, idx) => {
            const listItem: Record<string, unknown> = {
                "@type": "ListItem",
                "position": idx + 1,
                "name": item.name,
            };
            if (item.url) {
                listItem["item"] = toAbsoluteUrl(siteUrl, item.url);
            }
            return listItem;
        }),
    };

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{__html: JSON.stringify(schema)}}
        />
    );
}
